import React from 'react'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaStar } from "react-icons/fa";

function Speciality() {
    const settings = {
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 0,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
        ],
    };
    return (
        <div>
            <section className='logoipsum'>
                <div className="container d-flex flex-column text-center gap-4" data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1300">
                    <hr className='hr1' />
                    <div className="companies">
                        <Slider {...settings}>
                            <div className='d-flex align-items-center gap-4'>
                                <h3>Creative Agency</h3>
                                <FaStar style={{ color: '#FABF28' }} />
                            </div>

                            <div className='d-flex align-items-center gap-4'>
                                <h3>Digital Studio</h3>
                                <FaStar style={{ color: '#FABF28' }} />
                            </div>

                            <div className='d-flex align-items-center gap-4'>
                                <h3>Creative Agency</h3>
                                <FaStar style={{ color: '#FABF28' }} />
                            </div>

                            <div className='d-flex align-items-center gap-4'>
                                <h3>Digital Studio</h3>
                                <FaStar style={{ color: '#FABF28' }} />
                            </div>
                        </Slider>
                    </div>
                    <hr className='hr2' />
                </div>

            </section>
        </div>
    )
}

export default Speciality
